const Videos = [
  {
    index: 1,
    src: "https://www.youtube.com/embed/hlDfSKXy5-g",
  },
  {
    index: 2,
    src: "https://www.youtube.com/embed/0TGz_UIp3y8",
  },
  {
    index: 3,
    src: "https://www.youtube.com/embed/py_qHUjnpVE",
  },
  {
    index: 4,
    src: "https://www.youtube.com/embed/RpwcModYAcs",
  },
];
export default Videos;
